export default "__VITE_ASSET__Dm65CtWb__"